export default __webpack_public_path__ + "static/media/7.c6fcf788.jpg";